/**
 * Returns the closest scrollable parent element for the given element.
 */
export function getClosestScrollableParent (element) {
  while (element) {
    const currentElement = typeof element === 'string'
      ? document.querySelector(element)
      : element
    
    const styles = window?.getComputedStyle(currentElement)
    const overflowY = styles.overflowY
 
    if (((overflowY === 'auto' || overflowY === 'scroll') && currentElement.scrollHeight > currentElement.clientHeight) || currentElement.getAttribute('scroll-scope')) {
      return currentElement
    }

    element = currentElement.parentElement
  }
    

  if ((document.documentElement.scrollHeight > document.documentElement.clientHeight) || (document.body.scrollHeight > document.body.clientHeight)) {
    return document.documentElement
  }

  return null
}
 
/**
 * Scrolls to the specified element or selector with an optional offset.
 * @param {Event} e - The event to prevent default on (optional)
 * @param {string|Element} selector - The selector or element to scroll to
 * @param {number} yOffset - The vertical offset for scrolling
 * @param {Element} blockSelector - The block element to use as scroll context (optional)
 */
export function scrollTo (e, selector, yOffset = -80, blockSelector) {
  const scrollableParent = getClosestScrollableParent(blockSelector)

  if (e) {
    e.preventDefault()
  }

  let overflowYValue = null
  if (scrollableParent) {
    const styles = window.getComputedStyle(scrollableParent)
    overflowYValue = styles.getPropertyValue('overflow-y') ? styles.getPropertyValue('overflow-y') : scrollableParent.getAttribute('overflow-y')
  }

  const element = (typeof selector === 'object') ? selector : document.querySelector(selector)

  if (!element) {
    // Element to scroll to not found
    return
  }

  if (!blockSelector) {
    blockSelector = window
  }
    
  if (overflowYValue !== null && overflowYValue !== 'hidden' && scrollableParent) {
    const y = useElementBounding(element).top.value + (scrollableParent ? useScroll(scrollableParent).y.value : useScroll(window).y.value) + yOffset
    scrollableParent.scrollTo({ top: y, behavior: 'smooth' })
  } else {
    const y = useElementBounding(element).top.value + useScroll(window).y.value + yOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}

/**
 * Downloads a file from an API response.
 * Example: @click="downloadFile(useGetCampaignsDownloads('campaignEmailsTemplate'), 'campaignEmailsTemplate.svg')"
 * @param {Promise|Blob} response - The response to convert to a Blob
 * @param {string} fileName - The name for the downloaded file
 */
export async function downloadFile (response, fileName) {
  try {
    const url = window.URL.createObjectURL(new Blob([await response]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    // Clean up DOM and revoke the object URL
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error(error)
  }
}
